// {[experimentName]: {groups: ['group1','group2', ...'groupN'], salt: number}}

export const CCT_EXTRA_FILTERS_BUTTON = 'cctExtraFiltersButton';
export default {
    [CCT_EXTRA_FILTERS_BUTTON]: {
        groups: ['left', 'right'],
        salt: 1,
    },
};
